export interface EntryMethodIdentity {
  id?: string;
  key: string;
  label: string;
}

export function isSupersededEntryMethod<T extends EntryMethodIdentity>(method: T, methods: T[]): boolean {
  const key = method.key.trim();
  const label = method.label.trim().toLowerCase();
  if (!key || key === "signup" || !label) return false;

  return methods.some((other) => {
    if (other === method) return false;
    if (other.id && method.id && other.id === method.id) return false;
    const otherKey = other.key.trim();
    if (!otherKey || otherKey === key) return false;
    return otherKey.endsWith(`-${key}`) && other.label.trim().toLowerCase().includes(label);
  });
}

export function visibleEntryMethods<T extends EntryMethodIdentity>(methods: T[]): T[] {
  return methods.filter((method) => method.key !== "signup" && !isSupersededEntryMethod(method, methods));
}
